@if (isLoading$ | async) {
  @if (showBackdrop) {
    <div class="loading-backdrop"></div>
  }
  <div class="spinner-container" [ngClass]="getClass()">
    <mat-spinner [diameter]="diameter"></mat-spinner>
    @if (label) {
      <p class="loading-label">
        {{ label | translate }}
      </p>
    }
  </div>
}
